import '@/sass/components/_accordion.scss';

function initAccordion(): void {
  const triggers = document.querySelectorAll<HTMLElement>(
    '.accordion__item__title',
  );
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.parentElement;
      if (!item) {
        return;
      }
      const isOpen = item.classList.toggle('accordion__item--open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
}

// Auto-initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccordion);
} else {
  initAccordion();
}
